export function svgIcon(inner, size = 20) {
  return `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

export const ICONS = {
  code: svgIcon('<path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13 5l-2 14"/>', 16),
  costumes: svgIcon('<circle cx="9" cy="10" r="4"/><circle cx="15" cy="14" r="4"/>', 16),
  backdrops: svgIcon('<rect x="3" y="5" width="14" height="11" rx="1.5"/><path d="M7 20h14V9"/>', 16),
  sounds: svgIcon('<path d="M5 10v4h3l4 4V6L8 10H5zM16 9a4 4 0 010 6"/>', 16),
  paint: svgIcon('<path d="M5 19c2 0 3-1 3-3 0-4 8-3 8-8a5 5 0 00-10 1c0 3 3 3 3 6 0 2-1 4-4 4z"/>'),
  upload: svgIcon('<path d="M12 16V5M7 9l5-5 5 5M5 19h14"/>'),
  surprise: svgIcon('<path d="M12 3l2.2 4.6L19 8.2l-3.5 3.4.8 4.9L12 14.3 7.7 16.5l.8-4.9L5 8.2l4.8-.6z"/>'),
  record: svgIcon('<circle cx="12" cy="12" r="6" fill="#ec5959" stroke="#ec5959"/>'),
  play: svgIcon('<path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/>'),
  stop: svgIcon('<rect x="6" y="6" width="12" height="12" rx="1.5" fill="currentColor" stroke="none"/>'),
  fullscreen: svgIcon('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
  recompile: svgIcon('<path d="M20 12a8 8 0 10-2.3 5.5M20 12V6m0 6h-6"/>'),
  select: svgIcon('<path d="M5 4l6 16 2-6 6-2z"/>'),
  reshape: svgIcon('<path d="M5 8h14M5 16h14M8 5v14M16 5v14"/><circle cx="8" cy="8" r="1.4" fill="currentColor"/><circle cx="16" cy="16" r="1.4" fill="currentColor"/>'),
  brush: svgIcon('<path d="M5 19c2 0 3-2 4-4l8-8 3 3-8 8c-2 1-4 2-7 1z"/>'),
  line: svgIcon('<path d="M5 19L19 5"/>'),
  rect: svgIcon('<rect x="5" y="6" width="14" height="12" rx="1"/>'),
  ellipse: svgIcon('<ellipse cx="12" cy="12" rx="8" ry="6"/>'),
  text: svgIcon('<path d="M5 7V5h14v2M12 5v14M9 19h6"/>'),
  fill: svgIcon('<path d="M7 14l7-7 4 4-7 7H7zM6 18h4"/><path d="M16 6l2 2"/>'),
  eraser: svgIcon('<path d="M5 15l8-8 6 6-8 8H7z"/>'),
  eyedrop: svgIcon('<path d="M14 5l5 5M8 16l7-7 3 3-7 7H8z"/>'),
  center: svgIcon('<circle cx="12" cy="12" r="3"/><path d="M12 3v4M12 17v4M3 12h4M17 12h4"/>'),
  undo: svgIcon('<path d="M3 8h9a5 5 0 1 1 0 10H8"/><path d="M7 4L3 8l4 4"/>'),
  redo: svgIcon('<path d="M21 8h-9a5 5 0 1 0 0 10h4"/><path d="M17 4l4 4-4 4"/>'),
  zoomIn: svgIcon('<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M8 10.5h5M10.5 8v5"/>'),
  zoomOut: svgIcon('<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M8 10.5h5"/>'),
  zoomReset: svgIcon('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
  flipH: svgIcon('<path d="M12 3v18M5 8l5 4-5 4V8M19 8l-5 4 5 4V8"/>'),
  flipV: svgIcon('<path d="M3 12h18M8 5l4 5 4-5H8M8 19l4-5 4 5H8"/>'),
  rotate: svgIcon('<path d="M20 8a8 8 0 10 2 5M20 8V3m0 5h-5"/>'),
  rotateCcw: svgIcon('<path d="M4 8a8 8 0 10-2 5M4 8V3m0 5h5"/>'),
  snap: svgIcon('<path d="M8 3v8M4 7h8"/><path d="M16 13v8M12 17h8"/>'),
  group: svgIcon('<rect x="4" y="5" width="11" height="9"/><rect x="9" y="10" width="11" height="9"/>'),
  ungroup: svgIcon('<rect x="3" y="4" width="8" height="8"/><rect x="13" y="12" width="8" height="8"/>'),
  clear: svgIcon('<path d="M5 7h14M9 7V5h6v2M8 7l1 12h6l1-12"/>'),
  close: svgIcon('<path d="M6 6l12 12M18 6L6 18"/>'),
  toBitmap: svgIcon('<rect x="4" y="5" width="16" height="14" rx="1"/><path d="M8 15l3-3 2 2 3-4 2 5"/>'),
  toVector: svgIcon('<path d="M5 16l5-8 3 5 2-3 4 6"/><circle cx="10" cy="8" r="1.4" fill="currentColor"/><circle cx="13" cy="13" r="1.4" fill="currentColor"/>'),
  faster: svgIcon('<path d="M8 6l6 6-6 6M14 6l6 6-6 6"/>'),
  slower: svgIcon('<path d="M16 6l-6 6 6 6M10 6l-6 6 6 6"/>'),
  louder: svgIcon('<path d="M5 10v4h3l4 4V6L8 10H5zM16 8a5 5 0 010 8M18.5 6a8 8 0 010 12"/>'),
  softer: svgIcon('<path d="M5 10v4h3l4 4V6L8 10H5zM16 10a2.5 2.5 0 010 4"/>'),
  mute: svgIcon('<path d="M5 10v4h3l4 4V6L8 10H5zM16 9l5 6M21 9l-5 6"/>'),
  fadeIn: svgIcon('<path d="M5 18V6l12 6z" opacity=".35"/><path d="M9 18V6l12 6z"/>'),
  fadeOut: svgIcon('<path d="M19 18V6L7 12z" opacity=".35"/><path d="M15 18V6L3 12z"/>'),
  reverse: svgIcon('<path d="M7 7h10v4H7zM7 13h10v4H7z"/><path d="M4 12l3-3v6z"/>'),
  echo: svgIcon('<path d="M8 8v8M12 6v12M16 8v8"/>'),
  robot: svgIcon('<rect x="6" y="8" width="12" height="10" rx="2"/><path d="M12 4v4M9 12h.1M15 12h.1M9 15h6"/>'),
  trim: svgIcon('<path d="M6 6l6 12M18 6l-6 12M5 9h6M13 15h6"/>'),
};

export function iconButton(id, title, extraClass = '') {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = `icon-btn ${extraClass}`.trim();
  b.title = title;
  b.setAttribute('aria-label', title);
  b.innerHTML = ICONS[id] || title;
  return b;
}
